import type Vue from 'vue'

let i = 0

export function newRouteOnValueChange({
  ctx,
  valueName,
  callback,
}: {
  ctx: Vue
  valueName: string
  callback: (value: boolean) => any
}) {
  const flag = `_${i++}_`

  const pageName = ctx.$route.name

  const offValueWatcher = ctx.$watch(
    valueName,
    (value: boolean) => {
      if (value) {
        // 值为 true 且未进入时进入
        if (!ctx.$route.query[flag]) {
          ctx.$router.push({
            ...ctx.$route.query,
            query: {
              ...ctx.$route.query,
              [flag]: '1',
            },
          })
        }
      } else {
        // 值为 false 且已进入时返回
        if (ctx.$route.query[flag]) {
          ctx.$router.back()
        }
      }
    },
    {
      immediate: true,
    },
  )

  const offFlagWatcher = ctx.$watch(
    '$route',
    (route: Vue['$route']) => {
      if (route.name === pageName) {
        if (!route.query[flag]) {
          if ((ctx as any)[valueName]) {
            callback(false)
          }
        } else {
          callback(true)
        }
      }
    },
    {
      immediate: true,
    },
  )

  ctx.$once('hook:beforeDestroy', () => {
    offValueWatcher()
    offFlagWatcher()
  })
}
